import { Dialog, DialogContent, styled, useTheme } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { BootstrapDialog } from "../pages/newBuyNode/components/NodeModal";
import CloseModalButton from './Modal/components/CloseModalButton';

function TermsAndConditionsModal({ isOpen, onClose, termsData, selectedTerm }) {
  const theme = useTheme();
  const ref = useRef(null);
  const neutralLight = theme.palette.neutral.light;
  const dark = theme.palette.neutral.dark;
  const background = theme.palette.background.default;
  const primaryLight = theme.palette.primary.light;
  const alt = theme.palette.background.alt;
  const modalColor = theme.palette.bgColor.modalBg;
  const loaderBackgroundColor =
    theme.palette.type === "dark"
      ? theme.palette.primary.light
      : theme.palette.neutral.light;

  const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
    overflow: "hidden", // Hide scrollbar
    "&::-webkit-scrollbar": {
      display: "none",
    },
    overscrollBehavior: "none",
    "-ms-overflow-style": "none", // IE and Edge
    "scrollbar-width": "none", // Firefox
  }));
  return (
    <BootstrapDialog open={isOpen} onClose={onClose} className="hide-scrollbar">
      <CustomDialogContent
        sx={{
          overflowY: "auto",
          maxHeight: "600px",
          maxWidth: "560px",
          padding: 0,
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "-ms-overflow-style": "none",
          "scrollbar-width": "none",
        }}
      >
        <div className="h-full w-full font-inter bg-white dark:bg-[#1D1C2D]">
          {selectedTerm && (
            <div
              key={selectedTerm}
              className="flex flex-col items-start mx-auto rounded-lg"
            >
              {/* Wrap the button and heading in a flex container */}
              <div className="flex justify-between  md:items-start w-full  py-4 px-6 md:px-8 md:py-6 border-b border-lightGrayBlue dark:border-darkSlateBlue">
                <h2 className="text-base md:text-lg text-left md:text-center font-bold text-black dark:text-white">
                  {termsData[selectedTerm].title}
                </h2>
                <CloseModalButton closeModal={onClose} />
              </div>
              <div className="" />
              {termsData[selectedTerm].sections.map((section, index) => (
                <div
                  key={index}
                  className="py-4 px-6 md:px-8 md:py-6 hide-scrollbar"
                >
                  {section.title && (
                    <h3 className="text-lg font-semibold text-black dark:text-white">
                      {section.title}
                    </h3>
                  )}
                  {/* Add margin-bottom to the <h1> element */}
                  {section.title === "Founder's Node" && (
                    <h1
                      className="text-lg font-semibold text-black dark:text-white"
                      // style={{ marginBottom: "10px" }}
                    >
                      <u>{section.title}</u>
                    </h1>
                  )}
                  <div
                    className="text-semiBlack dark:text-semiWhite hide-scrollbar text-justify"
                    dangerouslySetInnerHTML={{ __html: section.content }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </CustomDialogContent>
    </BootstrapDialog>
  );
}

export default TermsAndConditionsModal;
